document.addEventListener('click', function (e) {
  const btn = e.target.closest('.swatch__btn');
  if (!btn) return;

  const picker = btn.closest('block-variant-picker');
  if (!picker) return;

  const idx = Number(btn.getAttribute('data-option-index')); // 0,1,2...
  const val = btn.getAttribute('data-value');

  // Marcar visualmente seleccionado en ese grupo
  const group = btn.closest('.product-form__swatches');
  if (group) {
    group.querySelectorAll('.swatch__btn').forEach(b => b.classList.remove('is-selected', 'is-active', 'selected'));
    btn.classList.add('is-selected');
  }

  // Si existe el <select> de esa opción, lo actualizamos y disparamos change
  const sel = picker.querySelector(`select[name="option${idx + 1}"]`);
  if (sel) {
    // si el valor no está (porque ocultaste agotados), no hacemos nada raro
    const opt = Array.from(sel.options).find(o => o.value === val);
    if (opt) {
      sel.value = val;
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  } else {
    // Fallback: avisa al componente por si el tema escucha eventos en el contenedor
    picker.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: { optionIndex: idx, value: val }
    }));
  }
});
